import { render } from "./LandingOpening.vue?vue&type=template&id=1935a800&scoped=true"
import script from "./LandingOpening.vue?vue&type=script&lang=js"
export * from "./LandingOpening.vue?vue&type=script&lang=js"

import "./LandingOpening.vue?vue&type=style&index=0&id=1935a800&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1935a800"]])

export default __exports__